<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <label for="input-dtliberacao">Data inicial</label>
          <b-form-datepicker
            id="datepicker-placeholder"
            v-model="dataInicial"
            required
            placeholder="Data do curso"
            locale="pt-BR"
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker>
        </b-col>

        <b-col cols="1">
          <label for="input-dtliberacao">Data final</label>
          <b-form-datepicker
            id="datepicker-placeholder"
            v-model="dataFinal"
            required
            placeholder="Data do curso"
            locale="pt-BR"
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker>
        </b-col>

        <b-col cols="1" class="mt-2 mb-0">
          <label for="select-empresa"></label>
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="success"
            block
            class="mr-2 mt-1"
            @click="getConvocacao()"
          >
            Processar
          </b-button>
        </b-col>

        <b-col cols="4" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro  ,Nome  ,Curso"
          ></b-form-input>
        </b-col>

        <b-col cols="1" class="mt-2">
          <label for="select-empresa"></label>
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="primary"
            block
            class="mr-2 mt-1"
            @click="postNotificacaoGrupo()"
          >
            Enviar notificações
          </b-button>
        </b-col>

        <LoadingModal v-if="isLoading" />
      </b-row>
      <p class="mt-2"></p>
    </b-form>

    <b-row>
      <b-col cols="12">
        <b-table
          id="convocacoes"
          class="globus"
          small
          hover
          striped
          sticky-header="980px"
          :items="itemsFiltered"
          :fields="gridConvocacao"
        >
          <template slot="cell(actions)" slot-scope="data">
            <b-button
              @click="
                postNotificacaoIndividual(
                  data.item.REGISTRO,
                  data.item.CURSO,
                  data.item.DATA_CURSO
                )
              "
              :title="'Notificar convocado - ' + data.item.REGISTRO"
              size="sm"
              variant="warning"
              class="mr-2 mt-2"
            >
              <i class="fa fa-comment"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "KontrowMonitoramento",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let searchLower = this.search.toLowerCase();
      return this.convocacoes.filter((item) => {
        return (
          item.REGISTRO.toLowerCase().includes(searchLower) ||
          item.CURSO.toLowerCase().includes(searchLower) ||
          item.NOME.toLowerCase().includes(searchLower)
        );
      });
    },
  },

  data: function () {
    return {
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      value_empresa: [], // [this.empresas],
      convocacoes: [],
      isLoading: false,
      dataInicial: "",
      dataFinal: "",

      search: "",

      gridConvocacao: [
        { key: "ID_FILIAL_ERP", label: "Filial", sortable: true },
        { key: "DATA_CURSO", label: "Data do curso", sortable: true },
        { key: "REGISTRO", label: "Registro", sortable: true },
        { key: "NOME", label: "Nome", sortable: true },
        { key: "FUNCAO", label: "Função", sortable: true },
        { key: "CURSO", label: "Curso", sortable: true },
        { key: "INSTITUICAO", label: "Instituição", sortable: true },
        { key: "SALA", label: "Sala", sortable: true },
        { key: "STATUS", label: "Status", sortable: true },
        { key: "CONFIRMADO", label: "Confirmado", sortable: true },
        { key: "actions", label: "Notificações" },
      ],
    };
  },

  components: { LoadingModal, Multiselect },
  methods: {
    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    getConvocacao() {
      // 1. Verificação de consistência
      if (
        !this.dataInicial ||
        !this.dataFinal ||
        !this.user.orc ||
        !this.value_empresa ||
        this.value_empresa.length === 0
      ) {
        showError("Por favor, preencha todos os campos obrigatórios.");
        return; // Interrompe a execução da função se a validação falhar
      }

      // 2. Dispara o evento somente se a validação for bem-sucedida
      this.isLoading = true;

      const formattedDataInicial = moment(this.dataInicial).format(
        "DD/MM/YYYY"
      );
      const formattedDataFinal = moment(this.dataFinal).format("DD/MM/YYYY");

      let params = {
        orc: this.user.orc,
        empresa_id: this.value_empresa[0].id_empresa,
        data_Inicial: formattedDataInicial,
        data_Final: formattedDataFinal,
      };

      axios
        .get(`${baseApiUrl}/glo/treinamento/convocacao`, { params })
        .then((res) => {
          this.convocacoes = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          showError(err);
        });
    },

    async postNotificacaoIndividual(REGISTRO, CURSO, DATA_CURSO) {
      this.isLoading = true;

      const dtCurso = moment(DATA_CURSO, "DD/MM/YYYY").format("YYYY-MM-DD");

      const corpo = {
        psg: this.user.psg,
        app: true,
        origem: "ML18",
        envio: "INDIVIDUAL",
        registro: REGISTRO,
        empresa_id: this.user.id_empresa,
        titulo_id: 7,
        origem_id: 4,
        status_id: 1,
        dt_curso: dtCurso,
        funcionario_cad_id: this.user.id_funcionario,
        descricao: `Você foi convocado para o curso "${CURSO}" no dia ${DATA_CURSO}. Por favor, confirme seu recebimento.`,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`;

      try {
        await axios.post(url, corpo); // aguarda a requisição

        this.$bvToast.toast("Notificação enviada com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (err) {
        showError(err);
      } finally {
        this.isLoading = false;
      }
    },

    async postNotificacaoGrupo() {
      this.isLoading = true;

      const notificacoes = this.convocacoes.map((item) => {
        const dtCurso = moment(item.DATA_CURSO, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
        const corpo = {
          psg: this.user.psg,
          app: true,
          registros: [item.REGISTRO],
          dt_curso: dtCurso,
          origem: "ML18",
          envio: "GRUPO",
          empresa_id: this.value_empresa[0].id_empresa,
          titulo_id: 7,
          origem_id: 4,
          status_id: 1,
          funcionario_cad_id: this.user.id_funcionario,
          descricao: `Você foi convocado para o curso "${item.CURSO}" no dia ${item.DATA_CURSO}. Por favor, confirme seu recebimento.`,
        };

        return axios.post(`${baseApiUrl}/sac/solicitacoes/notificacoes`, corpo);
      });

      try {
        await Promise.all(notificacoes);
        this.$bvToast.toast("Notificações enviadas com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (err) {
        showError(err);
      } finally {
        this.isLoading = false;
      }
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>